export const INTERVIEW = 'interview';
export const EXAMINATION = 'examination';
export const ASSESSMENT_CENTER = 'assessment-center';
export const TRIAL = 'trial';

const LABELS = {
	[INTERVIEW]: 'Gespräch (Telefonat, Videoanruf, persönlicher Termin)',
	[EXAMINATION]: 'Test',
	[ASSESSMENT_CENTER]: 'Assessment-Center (AC)',
	[TRIAL]: 'Probearbeit',
};

export function getLabel (reason)
{
	return LABELS[reason];
}
